export default "/images/vendor/flag-icon-css/flags/4x3/sr.svg?690504905775fc1b1480f659e631a028";